export default class BaseSensorsConfig {
  // 是否打印神策日志
  show_log?: boolean = false;

  // 神策上传地址，默认为客渠上传地址
  server_url?: string = 'https://ubs.sf-express.com/sa?project=entercust';

  // 自定义渠道号
  source_channel?: string[];
}
